import { render } from "./recut-new.vue?vue&type=template&id=b357381a&scoped=true"
import script from "./recut-new.vue?vue&type=script&lang=js"
export * from "./recut-new.vue?vue&type=script&lang=js"

import "./recut-new.vue?vue&type=style&index=0&id=b357381a&scoped=true&lang=css"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b357381a"]])

export default __exports__